module.exports = __webpack_public_path__ + "img/cover-minigame-bg-mobile.a4ca97c5.png";